import fetchWebApi from 'api/fetchWebApi';

const getConsentsApiCall = async (): Promise<any> =>
  fetchWebApi('/external/consents/data');

export default getConsentsApiCall;
